export async function getConusPerDiem(zip: string) {
  const r = await fetch(`/api/perDiem?zip=${zip}`)
  if (!r.ok) throw new Error('fail')
  return (await r.json())[0]
}

export async function getOconusPerDiem(country: string, city?: string) {
  const d = await fetch('/data/oconus2025.json').then((r) => r.json())
  return (
    d.find(
      (x: any) =>
        x.country.toUpperCase() === country.toUpperCase() &&
        (!city || x.city.toUpperCase() === city.toUpperCase()),
    ) || null
  )
}
